ACC.cartpopup = {

	bindAll: function ()
	{
		this.bindCartPop();
	},

	bindCartPop: function ()
	{/*
		$('#rollover_cart_popup').hide();

		$('#cart_content').hover(
				function ()
				{
					$.data(this, 'hover', true);
				},
				function ()
				{
					$.data(this, 'hover', false);
				}
		).data('hover', false);

		$('#rollover_cart_popup').hover(
				function ()
				{
					$.data(this, 'hover', true);
				},
				function ()
				{
					$.data(this, 'hover', false);
				}
		).data('hover', false);

		$('#cart_content').mouseenter(function ()
		{
			$('#cart_popup').hide();
			$.ajax({
				url: rolloverPopupUrl,
				cache: false,
				type: 'GET',
				success: function (result)
				{
					$('#rollover_cart_popup').html(result);
					$('#rollover_cart_popup .scroll').slimScroll({
					      height: 180,
					      alwaysVisible: true,
					      allowPageScroll: false,
					      position: 'right',
					      color: '#888',
					      distance: 0,
					      railVisible: true,
					      wheelStep: 10
					  });
					$('#rollover_cart_popup').fadeIn();
				}
			});
		});

		$(document).on('click', '#ajax_cart_close', function (e)
		{
			e.preventDefault();
			$('#rollover_cart_popup').hide();
		});

		$('#cart_content').mouseleave(function ()
		{
			setTimeout(function ()
			{
				if (!$('#cart_content').data('hover') && !$('#rollover_cart_popup').data('hover'))
				{
					$('#rollover_cart_popup').fadeOut();
				}
			}, 100);
		});

		$('#rollover_cart_popup').mouseenter(function ()
		{
			$('#rollover_cart_popup').show();
		});
		$('#rollover_cart_popup').mouseleave(function ()
		{
			setTimeout(function ()
			{
				if (!$('#cart_content').data('hover') && !$('#rollover_cart_popup').data('hover'))
				{
					$('#rollover_cart_popup').fadeOut();
				}
			}, 100);
		});*/

		  $('#cart_header').on('click', function (e) {
				$('#cart_popup').hide();
				$.ajax({
					url: rolloverPopupUrl,
					cache: false,
					type: 'GET'
        }).done(function (result) {
						$('#rollover_cart_popup').html(result);
            if($('#rollover_cart_popup .slimScrollActive').length > 0) {
              $('#rollover_cart_popup .scroll .nice-scrollable').css('max-height',Math.min(370,$(window).height() - 300)+"px");
              var ps = new PerfectScrollbar('#rollover_cart_popup .scroll .nice-scrollable', {
                suppressScrollX: true,
                wheelPropagation: false
              });
              $("#rollover_cart_popup .slimScrollActive, #rollover_cart_popup .total-cart").on("touchstart ps-y-reach-end", function (event) {
                if (event.cancelable) {
                  event.preventDefault();
                  event.stopPropagation();
                }
              });
            }

//					$('#rollover_cart_popup').fadeIn();
				});

		    });

	},

	refreshMiniCart : function()
	{
		$.get(refreshMiniCartUrl + Math.floor(Math.random() * 101) * (new Date().getTime()), function (result)
		{
            $('#minicart_data').html(result);
            if(result != "0") {
                $('#minicart_data').prop( "hidden", false );
            }else {
                $('#minicart_data').prop( "hidden", true );
            }
		});
	}
};

$(document).ready(function ()
{
	ACC.cartpopup.bindAll();
});

